export const SIDER_WIDTH = 250;
export const SIDER_WIDTH_COLLAPSE = 64;
export const HEADER_HEIGHT = 64;
/** Desktop list tables are at least this wide (matches Fulfillment) so every page scrolls horizontally with the sticky bar. */
export const LIST_TABLE_MIN_WIDTH = 1900;
